import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';
import { IAnchor } from '../_shared/models/anchor.model';

import { AnchorDirective } from '../_shared/directives';

@Component({
    selector: 'sirius-anchor',
    templateUrl: './anchor.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AnchorDirective]
})
export class AnchorComponent implements IDynamicElement, OnInit {
    config?: IAnchor;

    @Input() anchorText!: string;

    ngOnInit() {
        if (this.config) {
            this.anchorText = this.config.anchorText;
        }
    }
}
